<template>
  <div class="page">

    <el-alert
        title="目前仅支持辽宁朝阳地区使用"
        :closable="false"
        type="warning">
    </el-alert>

    <el-steps :active="active" finish-status="success">
      <el-step title="经办人认证"></el-step>
      <el-step title="备案信息录入"></el-step>
      <el-step title="付款"></el-step>
    </el-steps>

    <div v-if="active == 1" class="single-apply-area" v-loading="loading">
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            label-position="left"
        >

          <el-form-item label="企业信息" style="background-color: #fafafa" class="mt20" />

          <el-form-item prop="businessLicenseId" label="营业执照" class="input-item">

            <el-input style="display: none" v-model="ruleForm.businessLicenseId"></el-input>
            <el-upload
                :limit="1"
                ref="businessLicenseId"
                class="avatar-uploader"
                :show-file-list="false"
                :before-upload="(e) => handleBeforeUpload(e, 2)"
                :on-change="onChangeFront"
                action="/"
                accept="image/*"
            >
              <div class="flex-dir-center-center" style="width: 100%;height: 100%" @click.stop="changeUpload('businessLicenseId')">

                <img class="image-card" v-if="imageLicenseId" :src="imageLicenseId" alt/>
                <img
                    class="icon-check"
                    v-if="imageLicenseId"
                    @click.stop="checkImage('license')"
                    src="@/assets/login/icon-check-img.png"
                    alt
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>

              </div>

            </el-upload>
          </el-form-item>

          <el-form-item prop="orgCode" label="信用代码" class="input-item">
            <el-input
                v-model="ruleForm.orgCode"
                placeholder="请输入信用代码"
            >
            </el-input>
          </el-form-item>
          <div class="prompt">请对比信用代码识别的准确性</div>

          <el-form-item prop="orgName" label="企业名称" class="input-item">
            <el-input
                v-model="ruleForm.orgName"
                placeholder="请输入企业名称"
            ></el-input>
          </el-form-item>
          <div class="prompt">请对比企业名称识别的准确性</div>

          <el-form-item label="企业授权书" prop="authorisation" class="input-item">
            <el-input style="display: none" v-model="ruleForm.authorisation"></el-input>
            <el-upload
                class="avatar-uploader"
                :show-file-list="false"
                :before-upload="(e) => handleBeforeUpload(e, 3)"
                :on-change="onChangeReserve"
                action="/"
                accept="image/*"
            >
              <div class="flex-dir-center-center" style="width: 100%;height: 100%">
                <img class="image-card" v-if="imageAuthorization" :src="imageAuthorization" alt/>
                <img
                    class="icon-check"
                    v-if="imageAuthorization"
                    @click.stop="checkImage('auth')"
                    src="@/assets/login/icon-check-img.png"
                    alt
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item label="法人信息" style="background-color: #fafafa" class="mt20" />

          <el-form-item label="与经办人相同">
            <el-switch
                v-model="ruleForm.sameOperator"
                active-color="#13ce66"
                inactive-color="#ff4949">
            </el-switch>
          </el-form-item>

          <el-form-item  prop="legalPersonIdCardFront" v-if="!ruleForm.sameOperator" label="法人身份证正面" class="input-item">
            <el-input style="display: none" v-model="ruleForm.legalPersonIdCardFront"></el-input>
            <el-upload
                ref="idCardFrontId"
                class="avatar-uploader"
                :limit="1"
                :show-file-list="false"
                :before-upload="(e) => handleBeforeUpload(e, 0)"
                :on-change="onChangeFront"
                action="/"
                accept="image/*"
            >
              <div class="flex-dir-center-center" style="width: 100%;height: 100%" @click.stop="changeUpload('idCardFrontId')">
                <img class="image-card" v-if="imageUrlFront" :src="imageUrlFront" alt/>
                <img
                    class="icon-check"
                    v-if="imageUrlFront"
                    @click.stop="checkImage('front')"
                    src="@/assets/login/icon-check-img.png"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item prop="legalPersonIdCardBack" v-if="!ruleForm.sameOperator" label="法人身份证反面" class="input-item">
            <el-input style="display: none" v-model="ruleForm.legalPersonIdCardBack"></el-input>
            <el-upload
                class="avatar-uploader"
                :limit="1"
                :show-file-list="false"
                :before-upload="(e) => handleBeforeUpload(e, 1)"
                :on-change="onChangeReserve"
                action="/"
                accept="image/*"
            >
              <div class="flex-dir-center-center" style="width: 100%;height: 100%">
                <img class="image-card" v-if="imageUrlReserve" :src="imageUrlReserve" alt/>
                <img
                    class="icon-check"
                    v-if="imageUrlReserve"
                    @click.stop="checkImage('reserve')"
                    src="@/assets/login/icon-check-img.png"
                    alt
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item prop="legalPersonName" v-if="!ruleForm.sameOperator" label="法人姓名" class="input-item">
            <el-input
                v-model="ruleForm.legalPersonName"
                placeholder="请输入法人姓名"
            ></el-input>
          </el-form-item>

          <el-form-item prop="legalPersonId" v-if="!ruleForm.sameOperator" label="法人身份证号" class="input-item">
            <el-input
                v-model="ruleForm.legalPersonId"
                placeholder="请输入法人身份证号"
            ></el-input>
          </el-form-item>

          <el-form-item prop="legalPersonPhone" v-if="!ruleForm.sameOperator" label="手机号码" class="input-item">
            <el-input
                type="number"
                v-model="ruleForm.legalPersonPhone"
                :maxlength="11"
                placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>

          <el-form-item label="刻企信息" style="background-color: #fafafa" class="mt20" />

          <el-form-item prop="makeOrgCode" label="刻企名称" class="input-item">
            <el-select v-model="ruleForm.makeOrgCode" disabled placeholder="请选择">
              <el-option
                  v-for="item in makeOrgData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="印章信息" style="background-color: #fafafa" class="mt20" />

          <el-form-item prop="sealMaterial" label="印章材质" class="input-item">
            <el-select v-model="ruleForm.sealMaterial" placeholder="请选择">
              <el-option
                  v-for="item in materialData"
                  :key="item.id"
                  :label="item.goodsName"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="sealType" label="印章类型" class="input-item">
            <el-select v-model="ruleForm.sealType" multiple placeholder="请选择">
              <el-option
                  multiple
                  v-for="item in sealData"
                  :key="item.id"
                  :label="item.goodsName"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="金额" >
            <div style="height: 40px;width: 100%;display: flex;align-items: center;justify-content: flex-end;">
              <span>{{ totalAmount }}元</span>
            </div>
          </el-form-item>

          <el-form-item label="收货信息" style="background-color: #fafafa" class="mt20" />

          <el-form-item prop="consigneeAddress" label="收货地址" class="input-item">
            <el-input
                v-model="ruleForm.consigneeAddress"
                placeholder="请输入收货地址"
            ></el-input>
          </el-form-item>

          <el-form-item prop="consigneeName" label="收货人" class="input-item">
            <el-input
                v-model="ruleForm.consigneeName"
                placeholder="请输入收货人"
            ></el-input>
          </el-form-item>

          <el-form-item prop="consigneePhone" label="收货人电话" class="input-item">
            <el-input
                type="number"
                v-model="ruleForm.consigneePhone"
                :maxlength="11"
                placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>

        </el-form>

      <div class="bottom-box">
        <el-button type="primary" icon="el-icon-search" @click="downLoad">授权书模板下载</el-button>

        <el-button type="primary" style="width: 40%" @click="submitForm()">下一步</el-button>
      </div>
    </div>

    <el-empty v-if="active == 3" style="margin-top: 150px" description="支付成功" :image="require('@/assets/pay-success.png')"></el-empty>

    <div class="bottom-box" v-if="PhysicalSeal && active == 3">
      <el-button type="primary" style="width: 40%" @click="handleContinue()">继续申领</el-button>
    </div>

    <el-image-viewer v-if="isShowPics" :on-close="closeViewer" :url-list="srcList" />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import Cookies from "js-cookie";
export default {
  name: "index",
  components: { ElImageViewer },
  created() {
    this.PhysicalSeal = Cookies.get('PhysicalSeal')
    let id = this.$route.params.id || null
    this.ruleForm.id = id
    this.getGoodsList()
  },
  watch: {
    // isSame: {
    //   handler(newVal) {
    //     if (newVal) {
    //       this.$set(this.ruleForm, "operatorPhone", this.ruleForm.legalPersonPhone);
    //       this.$set(this.ruleForm, "operatorId", this.ruleForm.legalPersonId);
    //       this.$set(this.ruleForm, "operatorName", this.ruleForm.legalPersonName);
    //       this.$set(this.ruleForm, "operatorIdCardBack", this.ruleForm.legalPersonIdCardBack);
    //       this.$set(this.ruleForm, "operatorIdCardFront", this.ruleForm.legalPersonIdCardFront);
    //     } else {
    //       this.$set(this.ruleForm, "operatorPhone", '');
    //       this.$set(this.ruleForm, "operatorId", '');
    //       this.$set(this.ruleForm, "operatorName", '');
    //       this.$set(this.ruleForm, "operatorIdCardBack", '');
    //       this.$set(this.ruleForm, "operatorIdCardFront", '');
    //       this.$set(this, "imageUrlOperatorFront", '');
    //       this.$set(this, "imageUrlOperatorReserve", '');
    //     }
    //   },
    // },
    'ruleForm.sealMaterial': function (newValue, oldValue) {
        console.log(newValue)
      if (newValue) {
        this.sealData = []
        this.totalAmount = 0
        this.ruleForm.sealType = []
        this.goodList.forEach(item => {
          if (item.parentId == newValue) {
            this.sealData.push(item)
          }
        })
      }else {
        this.sealData = []
      }
    },
    'ruleForm.sealType': function (newValue, oldValue) {
      if (newValue.length > 0) {
        let ids = newValue.join(',')
        let money = 0
        this.sealData.forEach(item => {
          if (ids.includes(item.id)) {
            money = item.goodsPrice + money
          }
        })
        this.totalAmount = money
      }
    },
  },
  data() {
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!reg.test(value) && !this.disbaleList) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    var validCode = (rule, value, callback) => {
      let reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (value === "") {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else {
        callback();
      }
    };
    return {
      PhysicalSeal:null,
      makeOrgData:[{
        value: '912113027746077465',
        label: '朝阳市天隆信息印章制作有限公司'
      }],
      // 显示金额
      totalAmount: 0,
      isShowPics: false,
      visible: false,
      srcList: [],
      // 法人与经办人是否相同
      isSame: true,
      active: 1,
      imageLicenseId: "",
      imageUrlFront: "",
      imageUrlReserve: "",
      // 经办人身份证正面照片
      imageUrlOperatorFront: "",
      // 经办人身份证反面照片
      imageUrlOperatorReserve: "",
      imageAuthorization: "",
      ruleForm:{
        sameOperator: true,
        id: '',
        makeOrgCode: '912113027746077465',
        makeOrgName: '朝阳市天隆信息印章制作有限公司',
      },
      rules: {
        businessLicenseId: [
          {
            required: true,
            message: "请上传企业营业执照",
            trigger: "change",
          },
        ],
        legalPersonIdCardFront: [
          {
            required: true,
            message: "请上传法人身份证人像面照片",
            trigger: "change",
          },
        ],
        legalPersonIdCardBack: [
          {
            required: true,
            message: "请上传法人身份证国徽面照片",
            trigger: "change",
          },
        ],
        authorisation: [
          {
            required: true,
            message: "请上传企业授权书照片",
            trigger: "change",
          },
        ],
        orgCode: [{required: true, validator: validCode, trigger: "blur"}],
        orgName: [
          {required: true, message: "请输入企业名称", trigger: "blur"},
        ],
        consigneeAddress: [
          { required: true, message: '收货地址不能为空', trigger: 'blur'}
        ],
        consigneeName: [
          { required: true, message: '收货人不能为空', trigger: 'blur'}
        ],
        consigneePhone: [
          {required: true, validator: validPhone, trigger: "blur"}
        ],
        sealMaterial: [{required: true, message: "请选择印章材质", trigger: "blur"}],
        sealType: [{required: true, message: "请选择印章类型", trigger: "blur"}],
        makeOrgCode: [{required: true, message: "请选择刻企名称", trigger: "blur"}],
        legalPersonName: [{required: true, message: "请输入法人姓名", trigger: "blur"}],
        operatorName: [{required: true, message: "请输入经办人姓名", trigger: "blur"}],
        legalPersonId: [{required: true, validator: validIdCard, trigger: "blur"}],
        operatorId: [{required: true, validator: validIdCard, trigger: "blur"}],
        legalPersonPhone: [{required: true, validator: validPhone, trigger: "blur"}],
        operatorPhone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
      loading: false,
      sealData: [],
      // 材料数据
      materialData: [],
      // 商品价格列表
      goodList:[],
    }
  },
  methods:{
    downLoad(){
      window.open('https://www.lngsyz.com/app/授权书.docx')
    },

    handleContinue(){
      if (this.PhysicalSeal){
        this.$http.post(this.$api.H5.recreateApply).then(res => {
          if (res.data.code == 200){
            if (res.data.data.applyId){
              this.$router.replace({
                path: "/h5/authentication/" + res.data.data.applyId + '?result=SUCCESS',
              });
            }else {
              this.$router.replace({
                path: "/h5/operatorAuthentication",
              });
            }
            // this.$router.replace({
            //   path: "/h5/physicsSeal/" + res.data.data.applyId,
            // });
          }else {
            this.$message.error(res.data.msg)
          }
        })
      }else {
        this.$router.replace({
          path: "/h5/operatorAuthentication",
        });
      }
    },

    payDialog(url){
      this.$confirm('是否确认已经支付?', '提示', {
        confirmButtonText: '已支付',
        cancelButtonText: '重新支付',
        customClass: 'message-box',
      }).then(() => {
        this.queryPayStatus(url)
      }).catch(() => {
        location.href = url
        this.payDialog(url)
      });
    },

    queryPayStatus(){
      this.$http.post(this.$api.H5.queryPayStatus , {id: this.ruleForm.id}).then(res => {
        if (res.data.code == 200){
          if (res.data.data.payStatus) {
            this.active = 3
          }else {
            this.payDialog()
          }
        }else {
          this.payDialog()
        }
      })
    },

    getGoodsList(){
      this.$http.post(this.$api.H5.goods , {kqOrgCode: this.ruleForm.makeOrgCode}).then(res => {
        if (res.data.code == 200){
          let tableData = res.data.data.physicalGoods;
          tableData.forEach(e => {
            if (e.parentId == 0){
              this.materialData.push(e)
            }else {
              this.goodList.push(e)
            }
          })
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },

    closeViewer() {
      this.isShowPics = false;
    },

    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.loading = true
          let params = JSON.parse(JSON.stringify(this.ruleForm))
          params.sealType = params.sealType.join(',')
          delete params.sealMaterial;
          this.$http.post(this.$api.H5.apply , JSON.stringify(params)).then(res =>{
            if (res.data.code == 200){
              // window.location.assign(res.data.data.faceCertifyUrl)
              location.href = res.data.data.payScheme
              this.active = 2
              this.payDialog(res.data.data.payScheme)
              this.loading = false
            }else {
              this.$message.error(res.data.msg)
              this.loading = false
            }
          })
        }
      });
    },

    getSealType() {
      this.$http.post(this.$api.user.getSealType, {type: "business"}, {"Content-Type": "application/x-www-form-urlencoded"}).then(res => {
        if (res.data.code == 200) {
          this.sealData = res.data.data || []
        }
      })
    },

    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          this.imageUrlFront = e.target.result;
        } else if (type == 1) {
          this.imageUrlReserve = e.target.result;
        } else if (type == 2) {
          this.imageLicenseId = e.target.result;
        } else if (type == 3) {
          this.imageAuthorization = e.target.result;
        } else if (type == 4) {
          this.imageScene = e.target.result;
        } else if (type == 5) {
          this.imageUrlOperatorFront = e.target.result;
        } else if (type == 6) {
          this.imageUrlOperatorReserve = e.target.result;
        }
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },

    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    changeUpload(e){
      if(e == 'idCardFrontId' || e == 'businessLicenseId' || e == 'operatorIdCardFront'){
        if (typeof GSESC === 'object'){
          this.uploadType = e
          this.visible = true
        }else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }else if(e == 'scene'){
        if (this.ruleForm.legalPersonName && this.ruleForm.legalPersonId){
          this.uploadType = e
          this.visible = true
        }else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }
      // this.getEncryptStr()
    },

    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      }else if (flag == "operatorFront") {
        this.srcList.push(this.imageUrlOperatorFront);
      }else if (flag == "operatorReserve") {
        this.srcList.push(this.imageUrlOperatorReserve);
      }else if (flag == "license") {
        this.srcList.push(this.imageLicenseId);
      } else if (flag == "reserve") {
        this.srcList.push(this.imageUrlReserve);
      }else if (flag == "auth") {
        this.srcList.push(this.imageAuthorization);
      } else {
        this.srcList.push(this.imageScene);
      }
      this.isShowPics = true;
    },

    request(base, type) {
      let params = {
        businessCode: this.ruleForm.orgCode ? this.ruleForm.orgCode : null,
        type: '' + type,
        imageBase64: base,
      };
      if (type == 5) {
        params.type = '0';
      }else if (type == 6) {
        params.type = '1';
      }
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "legalPersonName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "legalPersonId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "legalPersonIdCardFront", res.data.data.imageId);
          } else if (type == 1) {
            this.$set(this.ruleForm, "legalPersonIdCardBack", res.data.data.imageId);
          } else if (type == 2) {
            this.$set(this.ruleForm, "businessLicenseId", res.data.data.imageId);
            if (res.data.data.businessName) {
              this.$set(this.ruleForm, "orgName", res.data.data.businessName);
            }

            if (res.data.data.businessCode) {
              this.$set(this.ruleForm, "orgCode", res.data.data.businessCode);
              this.$refs.ruleForm.clearValidate()
            }
          } else if (type == 3) {
            this.$set(this.ruleForm, "authorisation", res.data.data.imageId);
          } else if (type == 4) {
            this.$set(this.ruleForm, "checkId", res.data.data.imageId);
          } else if (type == 5) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "operatorName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "operatorId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "operatorIdCardFront", res.data.data.imageId);
          } else if (type == 6) {
            this.$set(this.ruleForm, "operatorIdCardBack", res.data.data.imageId);
          }
          if(res.data.data.errMsg){
            this.$message.warning(res.data.data.errMsg);
          }else {
            this.$message.success(res.data.msg);
          }
        } else {
          this.$message.error(res.data.msg);
          if (type == 0) {
            this.imageUrlFront = "";
          } else if (type == 1) {
            this.imageUrlReserve = "";
          } else if (type == 2) {
            this.imageLicenseId = "";
          } else if (type == 3) {
            this.imageAuthorization = "";
          } else if (type == 4) {
            this.imageScene = "";
          }
        }
        this.loading = false;
      });
    },
  }
}
</script>

<style >
.message-box {
  width: 90vw !important;
}
</style>

<style scoped lang="less">
::v-deep .el-form-item {
  padding: 10px 20px;
  margin-bottom: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ebedf0;
  background-color: #ffffff;
}

.input-item{
  padding: 10px 20px 18px 20px !important;
}

::v-deep .el-form-item__content {
  line-height: 0px
}

::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;height: 80px
}

.body {
  background-color: #f1f1f1;
}

::v-deep .el-form-item__error{
  background-color: #ffffff;
  text-align: left;
  width: 100%
}
.prompt{
  margin-top: -18px;
  font-size: 12px;
  text-align: left;
  padding-left: 170px;
  color: #409EFF;
}

.avatar-uploader{
  display: flex;
  justify-content: flex-end;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.el-step{
  text-align: left;
}

.el-steps{
  padding: 10px 20px 0 20px;
  background-color: #FFFFFF;
}

.el-switch{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
}

.bottom-box{
  width: 100%;
  height: 80px;
  position: fixed;
  bottom: 0;
  background-color: #FFFFFF;
  padding-top: 20px;
  z-index: 10;
}

.single-apply-area{
  position: absolute;
  width: 100%;
  padding-bottom: 100px;
}

</style>
